import {Box, Container, Link, Theme, Typography} from '@mui/material';
import {messages} from '@smartmixin/i18n';
import {useIntl} from 'react-intl';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary">
      {'Copyright © '}
      <Link color="inherit" href="/">
        SmartMixin
      </Link>{' '}
      {new Date().getFullYear()}
    </Typography>
  );
}

function TermsOfService() {
  const {formatMessage} = useIntl();
  return (
    <Typography variant="body2" color="textSecondary">
      <Link color="inherit" href="/terms-and-conditions">
        {formatMessage(messages.settings.termsOfService)}
      </Link>
    </Typography>
  );
}

function PrivacyPolicy() {
  const {formatMessage} = useIntl();
  return (
    <Typography variant="body2" color="textSecondary">
      <Link color="inherit" href="/privacy-policy">
        {formatMessage(messages.settings.privacyPolicy)}
      </Link>
    </Typography>
  );
}

function HelpCenter() {
  const {formatMessage} = useIntl();
  return (
    <Typography variant="body2" color="textSecondary">
      <Link color="inherit" href="/help">
        {formatMessage(messages.common.helpCenter)}
      </Link>
    </Typography>
  );
}

export default function StickyFooter() {
  return (
    <Box
      component="footer"
      sx={{
        padding: (theme: Theme) => theme.spacing(3, 2),
        marginTop: 'auto',
      }}>
      <Container
        maxWidth="md"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}>
        <Copyright />
        <HelpCenter />
        <TermsOfService />
        <PrivacyPolicy />
      </Container>
    </Box>
  );
}
